const scopes =
  "create:consulta_appointment create:hso_appointment list:consulta_appointment list:hso_appointment list:hso_service create:hso_service delete:hso_service update:hso_service read:consulta_appointment read:consulta_service read:hso_appointment update:consulta_appointment update:hso_appointment list:hso_workers create:hso_workers update:hso_workers delete:hso_workers list:payments";

export default scopes;
